import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { AuthModule } from "./auth/auth.module";
import { LearnsetViewModule } from "./learnset-view/learnset-view.module";
import { LearnsetsViewModule } from "./learnsets-view/learnsets-view.module";
import { DashboardModule } from "./dashboard/dashboard.module";
import { CourseViewModule } from "./course-view/course-view.module";
import { OnboardingModule } from "./onboarding/onboarding.module";
import { SettingsViewModule } from "./settings-view/settings-view.module";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { GetPremiumModule } from "./get-premium/get-premium.module";
import { PrivacyPolicyModule } from "./privacy-policy/privacy-policy.module";
import { CreateAiFlashcardsModule } from "./create/create-ai-flashcards/create-ai-flashcards.module";
import { CreateUploadFlashcardsModule } from "./create/create-upload-flashcards/create-upload-flashcards.module";
import { LearnQuestionAnswerModule } from "./learn/learn-question-answer/learn-question-answer.module";
import { LearnViewModule } from "./learn/learn-view/learn-view.module";
import { LearnWithAiModule } from "./learn/learn-with-ai/learn-with-ai.module";
import { CreateFlashcardsChatModule } from "./create/create-flashcards-chat/create-flashcards-chat.module";
import { ExamViewModule } from "./exam-view/exam-view.module";
import { CreateExamModule } from "./create-exam/create-exam.module";
import { ContactModule } from "./contact/contact.module";
import { LandingpageModule } from "./landingpage/landingpage.module";
import { SmartRepetitionModule } from "./smart-repetition/smart-repetition.module";
import { LearnAudioModule } from "./learn/learn-audio/learn-audio.module";

@NgModule({
  imports: [
    CommonModule,
    PdfViewerModule,
    CreateAiFlashcardsModule,
    AuthModule,
    LearnViewModule,
    LearnsetViewModule,
    LearnsetsViewModule,
    DashboardModule,
    CourseViewModule,
    OnboardingModule,
    SettingsViewModule,
    CreateUploadFlashcardsModule,
    GetPremiumModule,
    LearnWithAiModule,
    CreateFlashcardsChatModule,
    LearnQuestionAnswerModule,
    PrivacyPolicyModule,
    ExamViewModule,
    CreateExamModule,
    ContactModule,
    LandingpageModule,
    SmartRepetitionModule,
    LearnAudioModule
  ],
  exports: []
})
export class FeaturesModule {}